// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.markdown-renderer.markdown-body {
  background-color: inherit;
  color: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/common/ui/markdown-renderer/MarkdownRenderer.less"],"names":[],"mappings":"AACE;EACE,yBAAA;EACA,cAAA;AAAJ","sourcesContent":[".markdown-renderer {\n  &.markdown-body {\n    background-color: inherit;\n    color: inherit;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
